import React, { Component, Fragment } from "react";
import * as cornerstone from "cornerstone-core";
import * as cornerstoneMath from "cornerstone-math";
import * as cornerstoneTools from "cornerstone-tools";
import * as cornerstoneWebImageLoader from "cornerstone-web-image-loader";
import * as cornerstoneWADOImageLoader from "cornerstone-wado-image-loader";
import * as dicomParser from "dicom-parser";
import Hammer from "hammerjs";
import { Button, ButtonGroup, Row, Col, CardBody, Card } from 'reactstrap';
import Tooltip from '@material-ui/core/Tooltip';
import Spinner from 'react-bootstrap/Spinner';
import moment from 'moment';
import LinearScaleIcon from '@material-ui/icons/LinearScale';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faDownload, faCircleNotch, faArrowsAlt, faEraser, faPlay, faCrosshairs, faMicrophone, faNotesMedical, faKeyboard, faCalendar, faClipboardCheck, faCheck, faBan, faClock, faFileImage } from "@fortawesome/free-solid-svg-icons";
import CropFreeIcon from '@material-ui/icons/CropFree';
import ReplyAllIcon from '@material-ui/icons/ReplyAll';
import InvertColorsIcon from '@material-ui/icons/InvertColors';
import ShuffleIcon from '@material-ui/icons/Shuffle';
import TextRotationAngledownIcon from '@material-ui/icons/TextRotationAngledown';
import DaicomForm from './DaicomForm';
import AudioFileAdmision from '../../AudioPanel/AudioFileAdmision';
import Audiotrack from '@material-ui/icons/Audiotrack';
import ArrowBack from '@material-ui/icons/ArrowBack';
import history from '../../../history';
import Modal from '@material-ui/core/Modal';
import FormInterview from '../../Interview/components/FormInterview';
import PreviewImage from './PreviewImage';
import DecisionForAll from './DecisionForAll';
import { NotificationsAPI } from '../../Notifications/api/NotificationsAPI';
import { HTMLNotification } from '../../Notifications/components/HTMLNotification';
import NotificationsSockets from '../../Notifications/api/NotificationsSockets';
import { validateConfigurationsUserProfile } from '../../Notifications/api/NotificationsUser';

class ImageView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isDialogOpen: false,
            dataImages: [],
            isLoading: true,
            popoverOpen: false,
            age: '',
            audioRecOpen: false,
            openHistoryCli: false,
            anotherPageHistory: false,
            imageDecision: null,
            decisionForAll: null,
            decisionForAllModal: false,
            watchImages: true,
            isHoveringRecord: false,
            width: 0,
            height: 0
        };
        this.refHideImages = React.createRef();
    }

    componentDidMount() {
        console.log("DICOM", this.props)
        this.calculateAge();

        cornerstoneWebImageLoader.external.cornerstone = cornerstone;

        cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
        cornerstoneWADOImageLoader.external.cornerstone = cornerstone;


        cornerstoneTools.external.cornerstone = cornerstone;
        cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
        cornerstoneTools.external.Hammer = Hammer;

        cornerstoneTools.init({ globalToolSyncEnabled: true, showSVGCursors: true, });

        // Add our tool, and set it's mode
        const StackScrollMouseWheelTool = cornerstoneTools.StackScrollMouseWheelTool

        cornerstoneTools.addTool(cornerstoneTools.LengthTool);
        cornerstoneTools.addTool(cornerstoneTools.EraserTool);
        cornerstoneTools.addTool(cornerstoneTools.ZoomMouseWheelTool);
        cornerstoneTools.addTool(cornerstoneTools.PanTool);
        cornerstoneTools.addTool(cornerstoneTools.ProbeTool);
        cornerstoneTools.addTool(cornerstoneTools.WwwcTool);
        cornerstoneTools.addTool(cornerstoneTools.AngleTool);
        cornerstoneTools.addTool(cornerstoneTools.ArrowAnnotateTool);
        cornerstoneTools.addTool(cornerstoneTools.MagnifyTool);
        cornerstoneTools.addTool(cornerstoneTools.EllipticalRoiTool);
        cornerstoneTools.addTool(cornerstoneTools.BidirectionalTool);

        //cornerstoneTools.addTool(cornerstoneTools.StackScrollMouseWheelTool);
        //cornerstoneTools.addTool(StackScrollMouseWheelTool);
        cornerstoneTools.addTool(cornerstoneTools.StackScrollTool);

        cornerstoneWADOImageLoader.configure({ useWebWorkers: false });

        this.getImageData();
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    getImageData = async () => {

        const dataSend = {
            id_historia: parseInt(this.props.data.id_historia),
            id_admision: parseInt(this.props.data.id_admision)
        };

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/consultar-imagenes', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                if (data.length !== 0) {
                    this.setState({ dataImages: data, isLoading: false });
                    //this.showImg(data[0].ruta);

                    for (let i = 0; i < data.length; i++) {
                        this.listOfImgs(data[i], i);
                    }
                } else {
                    this.setState({ isLoading: false });
                }

            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    listOfImgs = (data, index) => {

        const elementMin = [];

        elementMin[index] = document.getElementById("min-" + index);
        cornerstone.enable(elementMin[index]);

        let imageId;

        if (data.dicom)
            imageId = "wadouri:" + process.env.REACT_APP_PUBLIC_URL + data.ruta + sessionStorage.getItem('token');
        else
            imageId = process.env.REACT_APP_PUBLIC_URL + data.ruta + sessionStorage.getItem('token');

        cornerstone.loadAndCacheImage(imageId).then(function (image) {
            cornerstone.displayImage(elementMin[index], image);
        });

    }

    showImg = (img) => {

        //const imageId = 'https://www.asteris.biz/Keystone/ImageDownload.aspx?ClinicCode=TESTKEYSTONE&ImageId=01b1755e-33d1-4b24-b9af-a4a019689d5f&ImageType=PreviewImage&FrameIndex=0';       
        //const dicom = "wadouri:https://raw.githubusercontent.com/ivmartel/dwv/master/tests/data/bbmri-53323707.dcm";

        const element = document.querySelector('.cornerstone-element');
        cornerstone.enable(element);

        let imageId;

        if (img.dicom)
            imageId = "wadouri:" + process.env.REACT_APP_PUBLIC_URL + img.ruta + sessionStorage.getItem('token');
        else
            imageId = process.env.REACT_APP_PUBLIC_URL + img.ruta + sessionStorage.getItem('token');

        cornerstone.loadImage(imageId).then(function (image) {
            cornerstone.displayImage(element, image);
        });
    }

    whereToRedirect = () => {
        let prevUrl = document.referrer;
    }

    calculateAge = () => {
        let fecha = moment(this.props.data.birthday, "YYYYMMDD").fromNow(true);
        this.setState({ age: fecha });
    }

    downloadCanvas = () => {
        var canvas = document.getElementById("main");
        var link = document.createElement('a');
        link.download = 'image.png';
        link.href = canvas.toDataURL()
        link.click();
    }

    backClinicHistory = () => {
        history.push({
            pathname: process.env.PUBLIC_URL + '/assitencial/clinic-history3',
            state: { data: this.props.data,
                estado_list_form: this.props.data.estado_list_form,
                pageIndex: this.props.pageIndex }
        });
    }

    backToListClinicHistory = () => {
        history.push({
            //pathname: process.env.PUBLIC_URL + '/assitencial/admissions',
            pathname: process.env.PUBLIC_URL + '/assitencial/search-clinic-history',
            state: { date: this.props.data.fecha,
                estado_list_form: this.props.data.estado_list_form,
                pageIndex: this.props.pageIndex
            }
        });
    }

    openHistoryClinic = () => {
        this.setState({ openHistoryCli: false });
    };

    handlerChangeOpening = () => {
        this.setState({ anotherPageHistory: false })
    }

    changeStateImage = async (image, approve, observation) => {
        const user = JSON.parse(sessionStorage.getItem('usuario'));
        let dataSend = {
            id_admision: this.props.data.id_admision,
            id: image.id,
            aprobacion: approve,
            doctor: user.id_usuario,
            observacion_doctor: observation
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/cambiar-estado', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Test");
            }
        }).then(data => {
            let dataImages = this.state.dataImages.concat([]);
            let indexData = dataImages.findIndex(img => img.id == image.id);
            dataImages[indexData].estado = approve == true ? 2 : 3;
            this.setState({ dataImages: dataImages });
        })
    }

    aproveAllImages = () => {
        this.setState({
            decisionForAll: true,
            decisionForAllModal: true
        });
    }

    declineAllImages = () => {
        this.setState({
            decisionForAll: false,
            decisionForAllModal: true
        });
    }

    closeAllDecision = () => {
        this.setState({
            decisionForAll: null,
            decisionForAllModal: false
        });
    }

    sendNotificationImageApproveDecline = async (approve) => {
        try {
            await validateConfigurationsUserProfile(this.state.dataImages[0].tecnologo, 4).then((notConfig) => {
                if (notConfig.not_configuracion != null && notConfig.not_configuracion != undefined) {
                    console.log("notConfig", notConfig);
                    let usuario_conectado = JSON.parse(sessionStorage.getItem('usuario'));
                    let remitente = usuario_conectado.nombre.split(' ')[0] + ' ' + usuario_conectado.nombre.split(' ')[1];
                    let fecha_notificacion = moment().tz("America/Bogota").format("YYYY-MM-DD HH:mm:ss");
                    let notification = new NotificationsAPI();
                    notification.vista = false;
                    notification.id_usuario = this.state.dataImages[0].tecnologo;
                    notification.id_admision = this.props.data.id_admision;
                    notification.id_historia = this.props.data.id_historia;

                    if (approve == true) {
                        notification.asunto = "Aprobación de Imagen Diagnostica";
                    }
                    else {
                        notification.asunto = "Rechazo de Imagen Diagnostica";
                    }

                    notification.remitente = remitente;
                    let msjAceptacion = approve == true ? "Aceptada" : "Rechazada";
                    let msjContinuo = ' una o mas imagenes diagnosticas del Paciente ' + this.props.data.nombres + ' en la Admision ';
                    notification.notificacion = msjAceptacion + msjContinuo + this.props.data.id_admision;
                    notification.id_notificaciones_tipo = 4;
                    notification.fecha_notificacion = fecha_notificacion;
                    notification.addNotification().then((not) => {
                        let htmlNotificacion = new HTMLNotification();
                        notification.id_notificacion = not.notificacion.id_notificacion;
                        notification.html_notificacion = htmlNotificacion.notificationTranscriptionResponseDoctor(fecha_notificacion, msjAceptacion, msjContinuo, this.props.data.id_admision);
                        notification.sendHTMLNotification().then((res_not) => {
                            NotificationsSockets.sendNotification(notification);
                            return res_not;
                        }).catch((err) => {
                            console.log(err);
                            return false;
                        });
                    });
                }
            });
        }
        catch (e) {
            console.log(e.stack);
            return false;
        }
    }

    handlerOpenImages = () => {
        this.setState({ watchImages: !this.state.watchImages })
    }

    handleMouseOverRecord = () => {
        this.setState(() => ({ isHoveringRecord: true }));
    }

    handleMouseOutRecord = () => {
        this.setState(() => ({ isHoveringRecord: false }));
    }

    handlerShowAudioPanel = () => {
        this.setState(() => ({ isHoveringRecord: !this.state.isHoveringRecord }));
    }

    updateWindowDimensions = () => {
        this.setState({ width: /* document.body.clientWidth */ window.innerWidth, height: /* document.body.clientHeight */ window.innerHeight }, () => console.log("ANCHO: ", this.state.width, "ALTO: ", this.state.height));
    }

    render() {
        const { height, width } = this.state;
        const StackScrollTool = cornerstoneTools.StackScrollTool;
        const AudioPanel = () => {
            return (<AudioFileAdmision dataPatient={this.props.dataPatient} data={this.props.dataPatient} id_admision={this.props.data.id_admision} audioRecOpen={this.state.audioRecOpen} closeAudioRec={() => { this.setState({ audioRecOpen: false }) }} />);
        }

        return (
            <div style={{ backgroundColor: 'black', display: 'flex', flexDirection: 'row', height: height + '-60px', width: "100%" }}>
                <Row style={{ width: '100%' }}>
                    <div className="card-dicom-viewer">
                        <div ref={this.refHideImages} className='wraper-list-images' style={{ display: this.state.watchImages ? 'flex' : 'none', height: height + '-60px' }} >
                            <div className="side-list-images" style={{ height: height + '-60px' }}>
                                <div className="text-center">
                                    <h4 style={{ color: 'white', marginLeft: 10 }}>Lista de Imagenes </h4>
                                    <ButtonGroup size="small" aria-label="small outlined button group" vertical={width <= 770 ? true : false} >
                                        <Tooltip title="Aprobar Todas las imagenes Diagnosticas">
                                            <Button style={{ backgroundColor: 'black', margin: 0 }} className="btn btn-sm" color="success" onClick={() => this.aproveAllImages()}>
                                                Aprobar Todo
                                            </Button>
                                        </Tooltip>
                                        <Tooltip title="Rechazar Todas las imagenes Diagnosticas">
                                            <Button style={{ backgroundColor: 'black', margin: 0 }} className="btn btn-sm" color="danger" onClick={() => this.declineAllImages()}>
                                                Rechazar Todo
                                            </Button>
                                        </Tooltip>
                                    </ButtonGroup>

                                    <DecisionForAll
                                        decision={this.state.decisionForAll}
                                        opened={this.state.decisionForAllModal}
                                        closeDecision={() => {
                                            this.closeAllDecision();
                                        }}
                                        id_admision={this.props.data.id_admision}
                                        Callback={this.getImageData}
                                        sendNotificationImageApproveDecline={this.sendNotificationImageApproveDecline}
                                    />
                                </div>


                                {this.state.isLoading ? <Spinner animation="border" variant="success" /> :
                                    this.state.dataImages.map((img, index) => {
                                        return (
                                            <PreviewImage
                                                img={img}
                                                showImg={this.showImg}
                                                changeStateImage={this.changeStateImage}
                                                index={index}
                                                sendNotificationImageApproveDecline={this.sendNotificationImageApproveDecline}
                                            />
                                        );
                                    })
                                }
                                {
                                    this.state.openHistoryCli ?
                                        <div style={{ flexDirection: 'column', position: 'relative', overflowY: 'scroll' }} >
                                            <Modal
                                                open={this.state.openHistoryCli}
                                                onClose={this.openHistoryClinic}
                                                aria-labelledby="simple-modal-title"
                                                aria-describedby="simple-modal-description"
                                                style={{ zIndex: 1000, display: "block !important", }}
                                                disableScrollLock={false}
                                            >
                                                <div className="paperAppointment-flex" style={{ height: '70%', width: "90%", overflowY: "auto" }}>
                                                    <FormInterview dataPatient={this.props.data} seeInputDiag={this.state.anotherPageHistory} />
                                                </div>

                                            </Modal>
                                        </div> : null
                                }
                            </div>
                        </div>
                        <div className="cornerstone-element-wrapper">
                            <div className="wraper-top-tools">
                                <div className="top-icons-tools">
                                    <div>
                                        <Button
                                            color="primary"
                                            size="sm"
                                            onClick={() => {
                                                this.handlerOpenImages()
                                            }}
                                            style={{
                                                marginBottom: '1rem', backgroundColor: 'black', color: '#fff'
                                            }}
                                        >
                                            {this.state.watchImages ? 'Ocultar Imágenes' : 'Mostrar Imágenes'}
                                        </Button>
                                    </div>
                                    <div className="imaging-tools">
                                        <ButtonGroup size="lg">
                                            <Tooltip title="Regresar al listado de Historias Clinicas">
                                                <Button color="primary" style={{ backgroundColor: 'black' }} onClick={() => {
                                                    this.backToListClinicHistory();
                                                }}>
                                                    <ReplyAllIcon style={{ color: 'white' }} />

                                                </Button>
                                            </Tooltip>
                                            <Tooltip title="Regresar a Historia Clinica">
                                                <Button color="primary" style={{ backgroundColor: 'black' }} onClick={() => {
                                                    this.backClinicHistory();
                                                }}>
                                                    <ArrowBack style={{ color: 'white' }} />

                                                </Button>
                                            </Tooltip>
                                            <Tooltip title="Linea">
                                                <Button color="primary" style={{ backgroundColor: 'black' }} onClick={() => {
                                                    cornerstoneTools.setToolActive('Length', { mouseButtonMask: 1 });

                                                    for (let i = 0; i < this.state.dataImages.length; i++) {
                                                        let enabledElement = [];
                                                        enabledElement = document.getElementById("min-" + i);
                                                        cornerstoneTools.setToolDisabledForElement(enabledElement, 'Length', { mouseButtonMask: 1 });
                                                    }
                                                }}>
                                                    <LinearScaleIcon style={{ color: 'white' }} />
                                                </Button>
                                            </Tooltip>
                                            <Tooltip title="Angulo">
                                                <Button color="primary" style={{ backgroundColor: 'black' }} onClick={() => {
                                                    cornerstoneTools.setToolActive('Angle', { mouseButtonMask: 1 });

                                                    for (let i = 0; i < this.state.dataImages.length; i++) {
                                                        let enabledElement = [];
                                                        enabledElement = document.getElementById("min-" + i);
                                                        cornerstoneTools.setToolDisabledForElement(enabledElement, 'Angle', { mouseButtonMask: 1 });
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faAngleLeft} style={{ color: 'white' }} />

                                                </Button>
                                            </Tooltip>

                                            <Tooltip title="Ovalo">
                                                <Button color="primary" style={{ backgroundColor: 'black' }} onClick={() => {
                                                    cornerstoneTools.setToolActive('EllipticalRoi', { mouseButtonMask: 1 });

                                                    for (let i = 0; i < this.state.dataImages.length; i++) {
                                                        let enabledElement = [];
                                                        enabledElement = document.getElementById("min-" + i);
                                                        cornerstoneTools.setToolDisabledForElement(enabledElement, 'EllipticalRoi', { mouseButtonMask: 1 });
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faCircleNotch} style={{ color: 'white' }} />

                                                </Button>
                                            </Tooltip>
                                            <Tooltip title="Bidireccional">
                                                <Button color="primary" style={{ backgroundColor: 'black' }} onClick={() => {
                                                    cornerstoneTools.setToolActive('Bidirectional', { mouseButtonMask: 1 });

                                                    for (let i = 0; i < this.state.dataImages.length; i++) {
                                                        let enabledElement = [];
                                                        enabledElement = document.getElementById("min-" + i);
                                                        cornerstoneTools.setToolDisabledForElement(enabledElement, 'Bidirectional', { mouseButtonMask: 1 });
                                                    }
                                                }}>
                                                    <ShuffleIcon style={{ color: 'white' }} />

                                                </Button>
                                            </Tooltip>
                                            <Tooltip title="Anotacion">
                                                <Button color="primary" style={{ backgroundColor: 'black' }} onClick={() => {
                                                    cornerstoneTools.setToolActive('ArrowAnnotate', { mouseButtonMask: 1 });

                                                    for (let i = 0; i < this.state.dataImages.length; i++) {
                                                        let enabledElement = [];
                                                        enabledElement = document.getElementById("min-" + i);
                                                        cornerstoneTools.setToolDisabledForElement(enabledElement, 'ArrowAnnotate', { mouseButtonMask: 1 });
                                                    }
                                                }}>
                                                    <TextRotationAngledownIcon style={{ color: 'white' }} />
                                                </Button>
                                            </Tooltip>
                                            <Tooltip title="Zoom">
                                                <Button color="primary" style={{ backgroundColor: 'black' }} onClick={() => {
                                                    cornerstoneTools.setToolActive('ZoomMouseWheel', { mouseButtonMask: 1 });

                                                    for (let i = 0; i < this.state.dataImages.length; i++) {
                                                        let enabledElement = [];
                                                        enabledElement = document.getElementById("min-" + i);
                                                        cornerstoneTools.setToolDisabledForElement(enabledElement, 'ZoomMouseWheel', { mouseButtonMask: 1 });
                                                    }
                                                }}>
                                                    <ZoomInIcon style={{ color: 'white' }} />
                                                </Button>
                                            </Tooltip>
                                            <Tooltip title="Lupa">
                                                <Button color="primary" style={{ backgroundColor: 'black' }} onClick={() => {
                                                    cornerstoneTools.setToolActive('Magnify', { mouseButtonMask: 1 });

                                                    for (let i = 0; i < this.state.dataImages.length; i++) {
                                                        let enabledElement = [];
                                                        enabledElement = document.getElementById("min-" + i);
                                                        cornerstoneTools.setToolDisabledForElement(enabledElement, 'Magnify', { mouseButtonMask: 1 });
                                                    }
                                                }}>
                                                    <CropFreeIcon style={{ color: 'white' }} />

                                                </Button>
                                            </Tooltip>
                                            <Tooltip title="Mover">
                                                <Button color="primary" style={{ backgroundColor: 'black' }} onClick={() => {
                                                    cornerstoneTools.setToolActive('Pan', { mouseButtonMask: 1 });

                                                    for (let i = 0; i < this.state.dataImages.length; i++) {
                                                        let enabledElement = [];
                                                        enabledElement = document.getElementById("min-" + i);
                                                        cornerstoneTools.setToolDisabledForElement(enabledElement, 'Pan', { mouseButtonMask: 1 });
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faArrowsAlt} style={{ color: 'white' }} />
                                                </Button>
                                            </Tooltip>
                                            <Tooltip title="Punto">
                                                <Button color="primary" style={{ backgroundColor: 'black' }} onClick={() => {
                                                    cornerstoneTools.setToolActive('Probe', { mouseButtonMask: 1 });

                                                    for (let i = 0; i < this.state.dataImages.length; i++) {
                                                        let enabledElement = [];
                                                        enabledElement = document.getElementById("min-" + i);
                                                        cornerstoneTools.setToolDisabledForElement(enabledElement, 'Probe', { mouseButtonMask: 1 });
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faCrosshairs} style={{ color: 'white' }} />
                                                </Button>
                                            </Tooltip>
                                            <Tooltip title="Nivel">
                                                <Button color="primary" style={{ backgroundColor: 'black' }} onClick={() => {
                                                    cornerstoneTools.setToolActive('Wwwc', { mouseButtonMask: 1 });

                                                    for (let i = 0; i < this.state.dataImages.length; i++) {
                                                        let enabledElement = [];
                                                        enabledElement = document.getElementById("min-" + i);
                                                        cornerstoneTools.setToolDisabledForElement(enabledElement, 'Wwwc', { mouseButtonMask: 1 });
                                                    }
                                                }}>
                                                    <InvertColorsIcon style={{ color: 'white' }} />
                                                </Button>
                                            </Tooltip>
                                            <Tooltip title="Play">
                                                <Button color="primary" style={{ backgroundColor: 'black' }} onClick={() => {
                                                    /* cornerstoneTools.setToolActive('StackScroll', { mouseButtonMask: 1 });

                                                    for (let i = 0; i < this.state.dataImages.length; i++) {
                                                        let enabledElement = [];
                                                        enabledElement = document.getElementById("min-" + i);
                                                        cornerstoneTools.addStackStateManager(enabledElement, ['stack'])
                                                        cornerstoneTools.addToolState(enabledElement, 'stack', this.state.dataImages[i])
                                                        //cornerstoneTools.addToolForElement(enabledElement, 'StackScroll', { mouseButtonMask: 1 });
                                                        cornerstoneTools.setToolDisabledForElement(enabledElement, 'StackScroll', { mouseButtonMask: 1 });
                                                    } */
                                                }}>
                                                    <FontAwesomeIcon icon={faPlay} style={{ color: 'white' }} />
                                                </Button>
                                            </Tooltip>

                                            <Tooltip title="Borrar">
                                                <Button color="primary" style={{ backgroundColor: 'black' }} onClick={() => {
                                                    cornerstoneTools.setToolActive('Eraser', { mouseButtonMask: 1 });
                                                    for (let i = 0; i < this.state.dataImages.length; i++) {
                                                        let enabledElement = [];
                                                        enabledElement = document.getElementById("min-" + i);
                                                        cornerstoneTools.setToolDisabledForElement(enabledElement, 'Eraser', { mouseButtonMask: 1 });
                                                    }
                                                }}>
                                                    <FontAwesomeIcon icon={faEraser} style={{ color: 'white' }} />
                                                </Button>
                                            </Tooltip>
                                            <Tooltip title="Descargar">
                                                <Button id="Popover1" color="primary" style={{ backgroundColor: 'black' }} onClick={() => {
                                                    //this.setState({ isDialogOpen: true, popoverOpen: true })
                                                    this.downloadCanvas();
                                                }}>
                                                    <FontAwesomeIcon icon={faDownload} style={{ color: 'white' }} />
                                                </Button>
                                            </Tooltip>

                                        </ButtonGroup>
                                    </div>
                                    <div className="audio-panel-button">
                                        <Button
                                            color="primary"
                                            size="sm"
                                            onClick={() => this.handlerShowAudioPanel()}
                                            /* onMouseOver={()=>this.handleMouseOverRecord()} */
                                            style={{
                                                marginBottom: '1rem', backgroundColor: 'black', color: '#fff'
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faFileImage} style={{ color: 'white', marginRight: '.25em' }} />
                                            Panel de Grabaciones
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className="cornerstone-element">
                                <canvas id="main" class="cornerstone-canvas" ></canvas>
                            </div>

                        </div >
                        <div style={{ position: 'absolute', top: '15px', right: '5px' }} >
                            <div style={{ backgroundColor: 'rgba(0, 0, 0, .3)', backdropFilter: 'blur(5px)', borderRadius: 10, padding: '0.2em 1em', width: '250px', position: 'absolute', display: this.state.isHoveringRecord ? 'flex' : 'none', flexDirection: 'column', top: '30px', right: '5px' }} /* onMouseLeave={()=>this.handleMouseOutRecord()} */>
                                <div style={{ width: '100%' }}>
                                    <h4 style={{ opacity: 1, color: 'white', marginTop: 2 }}> Paciente </h4>
                                    <p style={{ opacity: 1, color: 'white', marginTop: 2 }}><b>Nombre: </b> {this.props.data.nombres} <br /><b>Edad: </b>{this.state.age} <br /><b> Sexo: </b> {this.props.data.sexo}</p>
                                </div>
                                <DaicomForm id_admision={this.props.data.id_admision} id_historia={this.props.data.id_historia} />
                                <AudioPanel id_admision={this.props.data.id_admision} id_historia={this.props.data.id_historia} />
                                <div style={{ alignSelf: 'flex-end' }}>
                                    <ButtonGroup>
                                        <Tooltip title="Registro Clínico">
                                            <Button color="primary" style={{ backgroundColor: 'black', marginTop: 10 }} onClick={() => {
                                                this.setState({ openHistoryCli: true })
                                            }}>
                                                <FontAwesomeIcon icon={faNotesMedical} style={{ color: '#A8ADC2' }} />
                                            </Button>
                                        </Tooltip>
                                        <Tooltip title="Modulo de Transcripción">
                                            <Button id="btnGrabar" color="primary" style={{ backgroundColor: 'black', marginTop: 10 }} onClick={() => {
                                                this.setState({ audioRecOpen: true })
                                            }}>
                                                <FontAwesomeIcon icon={faKeyboard} style={{ color: '#A8ADC2' }} />
                                            </Button>
                                        </Tooltip>
                                    </ButtonGroup>
                                </div>
                            </div>



                        </div>

                        <div className="imaging-tools-vertical" style={{ left: this.state.watchImages ? '260px' : '5px', top: '55px' }}>
                            <ButtonGroup vertical className="imaging-tools-vertical-group">
                                <Tooltip title="Regresar al listado de Historias Clinicas">
                                    <Button color="primary" style={{ backgroundColor: 'black', margin: 0 }} onClick={() => {
                                        this.backToListClinicHistory();
                                    }}>
                                        <ReplyAllIcon style={{ color: 'white' }} />

                                    </Button>
                                </Tooltip>
                                <Tooltip title="Linea">
                                    <Button color="primary" style={{ backgroundColor: 'black', margin: 0 }} onClick={() => {
                                        cornerstoneTools.setToolActive('Length', { mouseButtonMask: 1 });

                                        for (let i = 0; i < this.state.dataImages.length; i++) {
                                            let enabledElement = [];
                                            enabledElement = document.getElementById("min-" + i);
                                            cornerstoneTools.setToolDisabledForElement(enabledElement, 'Length', { mouseButtonMask: 1 });
                                        }
                                    }}>
                                        <LinearScaleIcon style={{ color: 'white' }} />
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Angulo">
                                    <Button color="primary" style={{ backgroundColor: 'black', margin: 0 }} onClick={() => {
                                        cornerstoneTools.setToolActive('Angle', { mouseButtonMask: 1 });

                                        for (let i = 0; i < this.state.dataImages.length; i++) {
                                            let enabledElement = [];
                                            enabledElement = document.getElementById("min-" + i);
                                            cornerstoneTools.setToolDisabledForElement(enabledElement, 'Angle', { mouseButtonMask: 1 });
                                        }
                                    }}>
                                        <FontAwesomeIcon icon={faAngleLeft} style={{ color: 'white' }} />

                                    </Button>
                                </Tooltip>

                                <Tooltip title="Ovalo">
                                    <Button color="primary" style={{ backgroundColor: 'black', margin: 0 }} onClick={() => {
                                        cornerstoneTools.setToolActive('EllipticalRoi', { mouseButtonMask: 1 });

                                        for (let i = 0; i < this.state.dataImages.length; i++) {
                                            let enabledElement = [];
                                            enabledElement = document.getElementById("min-" + i);
                                            cornerstoneTools.setToolDisabledForElement(enabledElement, 'EllipticalRoi', { mouseButtonMask: 1 });
                                        }
                                    }}>
                                        <FontAwesomeIcon icon={faCircleNotch} style={{ color: 'white' }} />

                                    </Button>
                                </Tooltip>
                                <Tooltip title="Anotacion">
                                    <Button color="primary" style={{ backgroundColor: 'black', margin: 0 }} onClick={() => {
                                        cornerstoneTools.setToolActive('ArrowAnnotate', { mouseButtonMask: 1 });

                                        for (let i = 0; i < this.state.dataImages.length; i++) {
                                            let enabledElement = [];
                                            enabledElement = document.getElementById("min-" + i);
                                            cornerstoneTools.setToolDisabledForElement(enabledElement, 'ArrowAnnotate', { mouseButtonMask: 1 });
                                        }
                                    }}>
                                        <TextRotationAngledownIcon style={{ color: 'white' }} />
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Zoom">
                                    <Button color="primary" style={{ backgroundColor: 'black', margin: 0 }} onClick={() => {
                                        cornerstoneTools.setToolActive('ZoomMouseWheel', { mouseButtonMask: 1 });

                                        for (let i = 0; i < this.state.dataImages.length; i++) {
                                            let enabledElement = [];
                                            enabledElement = document.getElementById("min-" + i);
                                            cornerstoneTools.setToolDisabledForElement(enabledElement, 'ZoomMouseWheel', { mouseButtonMask: 1 });
                                        }
                                    }}>
                                        <ZoomInIcon style={{ color: 'white' }} />
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Lupa">
                                    <Button color="primary" style={{ backgroundColor: 'black', margin: 0 }} onClick={() => {
                                        cornerstoneTools.setToolActive('Magnify', { mouseButtonMask: 1 });

                                        for (let i = 0; i < this.state.dataImages.length; i++) {
                                            let enabledElement = [];
                                            enabledElement = document.getElementById("min-" + i);
                                            cornerstoneTools.setToolDisabledForElement(enabledElement, 'Magnify', { mouseButtonMask: 1 });
                                        }
                                    }}>
                                        <CropFreeIcon style={{ color: 'white' }} />

                                    </Button>
                                </Tooltip>
                                <Tooltip title="Mover">
                                    <Button color="primary" style={{ backgroundColor: 'black', margin: 0 }} onClick={() => {
                                        cornerstoneTools.setToolActive('Pan', { mouseButtonMask: 1 });

                                        for (let i = 0; i < this.state.dataImages.length; i++) {
                                            let enabledElement = [];
                                            enabledElement = document.getElementById("min-" + i);
                                            cornerstoneTools.setToolDisabledForElement(enabledElement, 'Pan', { mouseButtonMask: 1 });
                                        }
                                    }}>
                                        <FontAwesomeIcon icon={faArrowsAlt} style={{ color: 'white' }} />
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Punto">
                                    <Button color="primary" style={{ backgroundColor: 'black', margin: 0 }} onClick={() => {
                                        cornerstoneTools.setToolActive('Probe', { mouseButtonMask: 1 });

                                        for (let i = 0; i < this.state.dataImages.length; i++) {
                                            let enabledElement = [];
                                            enabledElement = document.getElementById("min-" + i);
                                            cornerstoneTools.setToolDisabledForElement(enabledElement, 'Probe', { mouseButtonMask: 1 });
                                        }
                                    }}>
                                        <FontAwesomeIcon icon={faCrosshairs} style={{ color: 'white' }} />
                                    </Button>
                                </Tooltip>

                                <Tooltip title="Borrar">
                                    <Button color="primary" style={{ backgroundColor: 'black', margin: 0 }} onClick={() => {
                                        cornerstoneTools.setToolActive('Eraser', { mouseButtonMask: 1 });
                                        for (let i = 0; i < this.state.dataImages.length; i++) {
                                            let enabledElement = [];
                                            enabledElement = document.getElementById("min-" + i);
                                            cornerstoneTools.setToolDisabledForElement(enabledElement, 'Eraser', { mouseButtonMask: 1 });
                                        }
                                    }}>
                                        <FontAwesomeIcon icon={faEraser} style={{ color: 'white' }} />
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Descargar">
                                    <Button id="Popover1" color="primary" style={{ backgroundColor: 'black', margin: 0 }} onClick={() => {
                                        //this.setState({ isDialogOpen: true, popoverOpen: true })
                                        this.downloadCanvas();
                                    }}>
                                        <FontAwesomeIcon icon={faDownload} style={{ color: 'white' }} />
                                    </Button>
                                </Tooltip>

                            </ButtonGroup>
                        </div>
                    </div>
                </Row>
            </div >
        );
    }
}



export default ImageView;
